import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import iconNoSearchXDark700 from '../assets/icons-light-theme/icon-noSearchX-dark700.svg'
import { light, spacing } from '../constants/theme'
import { Text } from './core'
import { ImageIcon } from './ImageIcon'

export const EmptySearchWrapper = styled.div`
  width: 100%;
  padding: 0 40px;
  margin-top: 34px;
  box-sizing: border-box;
`

export const EmptySearchIcon = styled.div`
  width: 100%;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EmptySearchString = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`

const EmptySearch = ({ search }) => {
  const { t } = useTranslation()

  return (
    <EmptySearchWrapper>
      <EmptySearchIcon>
        <ImageIcon width={48} height={48} icon={iconNoSearchXDark700} />
      </EmptySearchIcon>
      <Text
        align="center"
        size="medium"
        text={t('emptySearch.shoot')}
        color={light.dark700}
        weight="bold"
      />
      <Text
        align="center"
        size="normal"
        text={t('emptySearch.nothingIsMatching')}
        color={light.dark700}
        style={{ marginBottom: `${spacing.spacingSM}` }}
      />
      <EmptySearchString>
        <Text size="normal" text="“" color={light.dark700} />
        <Text size="normal" text={search} color={light.dark900} weight="bold" />
        <Text size="normal" text="”" color={light.dark700} />
      </EmptySearchString>
      <Text
        align="center"
        size="normal"
        text={t('emptySearch.didYouSpellItRight')}
        color={light.dark900}
      />
    </EmptySearchWrapper>
  )
}

EmptySearch.propTypes = {
  search: PropTypes.string,
}

EmptySearch.defaultProps = {
  search: '',
}

export default EmptySearch
